export default "__VITE_ASSET__DwGBrN7D__"